import ImpactPill from "@/components/Impact/ImpactPill";

import Skeleton from "@/components/Skeleton/Skeleton";
import styles from "../ProductScenarios.module.scss";

export default function ProductScenarioCompareSkeleton() {
  return (
    <div className={`${styles.scenario}`}>
      <div className={styles.header}>
        <span className={styles.name}>
          <Skeleton style={{ width: 90, height: 16 }} />
        </span>
        <ImpactPill
          impact={undefined}
          loading={true}
        />
      </div>
    </div>
  );
}
